import { routes } from "@/pages";
import { createRouter, createWebHistory } from "vue-router";

const history = createWebHistory();
const router = createRouter({
  routes,
  history,
});

import { todayISODate } from "@/helpers/format";

router.beforeEach(async (to, from) => {
  if (to.query.date_start === "today") {
    to.query.date_start = todayISODate;
    return to;
  }
});

router.afterEach((from, to, error) => {
  error;
});

export default router;
